import "./AssignConditionModal.scss";

import AssignConditionModal from "./AssignConditionModal";

export default AssignConditionModal;
